__turbopack_context__.v({
  "className": "newsreader_3f151855-module__zsCMQG__className",
});
